import { FC } from 'react';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';

import { WithTooltip } from '../entries/entries.styles';
import { TooltipInfo } from './TooltipInfo/TooltipInfo';

export const CopyrightFeeTooltip: FC = () => {
    const { t } = useTranslations();

    return (
        <WithTooltip>
            {t['order_cart.copyright_fee']}
            <TooltipInfo icon="info-filled" content={t['order_cart.copyright_fee.tooltip_text']} />
        </WithTooltip>
    );
};
